import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { downloadFile } from "reducers/Download";
import { openModal } from "reducers/Modal";
import { BasicAction } from "widgets/ActionMenu";
import{  hasPermission, isSocialCreative, labelWithCount } from 'utils/common';
import { API_URL, MENU_DIVIDER, MODAL_TYPES } from "utils/constants";
import { selectedCreativesByMatch } from 'selectors/Creatives';

const CV ="Creative View";

function useSocialDownload(query){
	const dispatch = useDispatch();
	const libraryId = useSelector(state => state.libraryProperties.id);
	const url = `${API_URL}/crm/v1/creative-libraries/${libraryId}/creatives/social/export?${query}`;
	return () => { dispatch(downloadFile(url)); };
}

// Borrowed from ActionMenu a bit, dumbed down as <Button /> does the rest
export function buildDropdownList(actionLists = [], actionContext = {}) { /**
		actionLists is a list of lists.  Every time we begin a new list after the first, we add a menu divider
	*/
	let menu = [];
	for (const list of actionLists) {
		const filteredList = list.filter(({ shouldDisplay = ALWAYS_DISPLAY }) => shouldDisplay(actionContext));
		const newList = filteredList.map(action => ({
			...action,
			renderChild: action.renderChild || (() => <action.component {...action} dependentValues={actionContext} />),
		}));

		// Add divider if there are prior items in the menu
		if(menu.length > 0){
			menu.push(MENU_DIVIDER, ...newList);
		} else {
			menu = newList;
		}
	}

	return menu;
}

function ALWAYS_DISPLAY(){
	return true;
}

export const IMPORT_SOCIAL_CREATIVES = {
	name:"Import Social Creatives",
	icon:"fas fa-upload",
	shouldDisplay:({ user })=>{return hasPermission(user, CV, "Upload Ad Files");},
	component:() => {
		const dispatch = useDispatch()
			, { name, icon } = IMPORT_SOCIAL_CREATIVES
			, handleClick = () => dispatch(openModal(MODAL_TYPES.socialCreativeImport));

		return (
			<BasicAction
				name={name}
				iconName={icon}
				handleClick={handleClick}
				className="import-export-social-creative-button"
			/>
		);
	},
	renderChild:() => <IMPORT_SOCIAL_CREATIVES.component {...IMPORT_SOCIAL_CREATIVES} />,
};

export const EXPORT_SOCIAL_CREATIVES = {
	name:"Export Social Creatives",
	icon:"download",
	component:() => {
		const { name, icon } = EXPORT_SOCIAL_CREATIVES
			, handleClick = useSocialDownload("all=true");

		return (
			<BasicAction
				name={name}
				iconName={icon}
				handleClick={handleClick}
				className="import-export-social-creative-button"
			/>
		);
	},
	renderChild:() => <EXPORT_SOCIAL_CREATIVES.component {...EXPORT_SOCIAL_CREATIVES} />,
};

export const EXPORT_SELECTED_SOCIAL_CREATIVES = {
	name:"Export Selected Social Creatives",
	icon:"download",
	component:() =>  {
		const { name, icon } = EXPORT_SELECTED_SOCIAL_CREATIVES
			, creatives = useSelector(selectedCreativesByMatch(isSocialCreative))
			, creativeIds = creatives.map(creative => creative.id)
			, handleClick = useSocialDownload(`creativesIds=${creativeIds}`)
			, disabledAction = !creativeIds.length;

		return (
			<BasicAction
				name={labelWithCount(name, creativeIds.length)}
				iconName={icon}
				handleClick={handleClick}
				isDisabled={disabledAction}
				className="import-export-social-creative-button"
			/>
		);
	},
	renderChild:() => <EXPORT_SELECTED_SOCIAL_CREATIVES.component {...EXPORT_SELECTED_SOCIAL_CREATIVES} />,
};

export const SOCIAL_CREATIVE_IMPORT_TEMPLATE = {
	name:"Social Creative Import Template",
	icon:"download",
	component:() => {
		const { name, icon } = SOCIAL_CREATIVE_IMPORT_TEMPLATE
			// This action uses just the base URL without query parameters
			, handleClick = useSocialDownload(null);

		return (
			<BasicAction
				name={name}
				iconName={icon}
				handleClick={handleClick}
				className="import-export-social-creative-button"
			/>
		);
	},
	renderChild:() => <SOCIAL_CREATIVE_IMPORT_TEMPLATE.component {...SOCIAL_CREATIVE_IMPORT_TEMPLATE} />,
};


export const PRIVATE = {
	IMPORT_SOCIAL_CREATIVES,
	EXPORT_SOCIAL_CREATIVES,
	EXPORT_SELECTED_SOCIAL_CREATIVES,
	SOCIAL_CREATIVE_IMPORT_TEMPLATE,
	useSocialDownload,
};

export const  BULK_SOCIAL_IMPORT_EXPORT_ACTIONS_LISTS = [
	[
		IMPORT_SOCIAL_CREATIVES,
		EXPORT_SOCIAL_CREATIVES,
		EXPORT_SELECTED_SOCIAL_CREATIVES,
	],
	[
		SOCIAL_CREATIVE_IMPORT_TEMPLATE
	]
];
